import * as React from 'react';

export const ErrorModal = () => {
    return (
        <div>
            Error!
        </div>
    );
};